export default [
  {
    path: "/relatorios",
    component: () =>
      import(/* webpackChunkName: "relatorios" */ "../views/Relatorios.vue"),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "acompanhamento-de-vendas",
        component: () =>
          import(
            /* webpackChunkName: "relatorios-vendas-" */
            "../components/relatorios/AcompanhamentoVendas.vue"
          ),
      },
      {
        path: "vendas-por-dia",
        component: () =>
          import(
            /* webpackChunkName: "relatorios-vendas-por-dia" */
            "../components/relatorios/VendasPorDia.vue"
          ),
      },
      {
        path: "vendas-por-periodo",
        component: () =>
          import(
            /* webpackChunkName: "relatorios-vendas-por-periodo" */
            "../components/relatorios/VendasPorPeriodo.vue"
          ),
      },
      {
        path: "historico-de-vendas",
        component: () =>
          import(
            /* webpackChunkName: "relatorios-vendas-historicos-de-status" */
            "../components/relatorios/HistoricoDeStatus.vue"
          ),
      },
    ],
  },
];
